import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogClaimNonDirectSecurityDepositComponent } from '@app/shared/components/dialog-claim-non-direct-security-deposit/dialog-claim-non-direct-security-deposit.component';
import { NonDirectSecurityDepositStatus, Reservation, SegmentEvent } from '@app/shared/interfaces';
import { PosthogService } from '@app/shared/services/posthog/posthog.service';

@Component({
  standalone: false,
  selector: 'sbnb-security-deposit-core-sidebar',
  templateUrl: './security-deposit-core-sidebar.component.html',
})
export class SecurityDepositCoreSidebarComponent {
  status = NonDirectSecurityDepositStatus;
  @Input() reservation: Reservation;
  @Output() securityDepositClaimed = new EventEmitter<void>();

  constructor(
    private dialog: MatDialog,
    private posthogService: PosthogService
  ) {}

  charge() {
    this.posthogService.capture(SegmentEvent.ChargeSecurityDeposit, {
      reservation_id: this.reservation.uuid,
    });

    this.dialog
      .open(DialogClaimNonDirectSecurityDepositComponent, {
        data: this.reservation,
      })
      .afterClosed()
      .subscribe((success) => {
        if (success) {
          this.securityDepositClaimed.emit();
        }
      });
  }
}
